import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { BaseSearchForm } from '@shared/ui/base-search-form';
import { UiGroupControl } from '@shared/ui/controls/ui-group-control.model';
import { ViewControl } from '@shared/ui/controls/view-control.model';
import { UiColumn } from '@shared/ui/ui-column';
import { ViewRowControl } from '@shared/ui/controls/view-row-control.model';
import { SearchGridComponent } from '../../../shared/components/grid/search-grid.component';
import { ToolBarComponent } from '@progress/kendo-angular-toolbar';
import { ToolbarItem } from '../../../shared/interfaces/tool-bar-item.interface';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';
import { RedeploymentOrderSearchResult } from '../../../shared/interfaces/gridrows/redeployment-order-search-result.interface';
import { AuthenticationService } from '../../../core/services/authentication.serivce';
import { ReadOnlyProperty, VisibleProperty } from '../../../shared/ui/control-options/control-option.interface';
import { ToggleControl } from '../../../shared/ui/controls/toggle-control.model';
import { OrderStatusSelect } from '../../../shared/ui/select-controls/order-status-select.model';
import { RedeploymentOrderStatus, Services } from '../../../shared/literals/shared.literal';
import { TextControl } from '../../../shared/ui/controls/text-control.model';
import { Permission } from '../../../core/literals/permission.literal';

@Component({
    selector: 'app-redeployment-order-list',
    templateUrl: './redeployment-order-list.component.html',
    styleUrls: ['./redeployment-order-list.component.css'],
    standalone: false
})
export class RedeploymentOrderListComponent extends BaseSearchForm<RedeploymentOrderSearchResult> implements OnInit {

  @ViewChild(SearchGridComponent) grid: SearchGridComponent;
  @ViewChild('toolbar') bar: ToolBarComponent;

  @Input() items: ToolbarItem[];
  /*  organizationId: Number | null;*/
  requiresShippingMethod: boolean = false;

  constructor(private router: Router,
              private auth: AuthenticationService) {
    super();

    this.name = "Orders";
    this.apiController = "RedeploymentOrder";
    this.keyFieldName = "id";
    this.canFilterSearch = this.auth.isAdmin();
    this.initializeUiControls();

    this.setGridSettings();
  }

  ngOnInit(): void {

  }

  override initializeUiControls() {

    try {


      const view = new ViewControl("");
      const search = new UiGroupControl("", "Search");

      var defaultStatus = new Array<any>;
      defaultStatus.push({ id: Number(RedeploymentOrderStatus.Open), name: RedeploymentOrderStatus[RedeploymentOrderStatus.Open] });
      if (this.auth.isAdmin()) {
        defaultStatus.push({ id: Number(RedeploymentOrderStatus.PendingCancellation), name: RedeploymentOrderStatus[RedeploymentOrderStatus.PendingCancellation] });
      }
      const statusSelect = new OrderStatusSelect("statusId", "Status", defaultStatus);
      const orderTextBox = new TextControl("order", "Order Number", "");

      const canViewAllOrders = new ToggleControl("viewAllOrders", "", this.auth.canPerformAction(Permission.ViewAllOrders));
      canViewAllOrders.addOption(new VisibleProperty((): boolean => { return false }));

      var row = new ViewRowControl();

      row.controls.push(statusSelect, orderTextBox, canViewAllOrders);

      search.rows.push(row);
      view.controls.push(search);

      this.views.push(view);

      if (this.auth.getSession()?.shippingMethodRequired == true) {
        this.requiresShippingMethod = true;

        const returningAssets = new TextControl("returningAssets", "Returning Asset Serial Number", "");

        if (this.requiresShippingMethod) {
          row.controls.push(returningAssets);
        }
      }
    } catch (err) {
      console.log(err);
    }
  }


  setGridSettings(): void {
    this.gridSettings = {
      gridName: "OrderSearch_Grid",
      showSubGrid: true,
      subGridColumns: this.getSubGridColumns(),
      subGridDataProperty: "trackingInformation",
      preloadData: true,
      columns: this.getColumns()
    };
  }

  private getSubGridColumns(): UiColumn[] {
    let cols: UiColumn[] = [];

    var direction = new UiColumn("direction", "Direction", 160);
    var trackingNumber = new UiColumn("trackingNumber", "Tracking Number", 160);
    var serviceUsed = new UiColumn("serviceUsed", "Service Used", 100);
    var status = new UiColumn("status", "Status", 200); 

    cols.push(direction, trackingNumber, serviceUsed, status);

    return cols;
  }

  private getColumns(): UiColumn[] {
    let cols: UiColumn[] = [];

    var orderNumber = new UiColumn("orderNumber", "Order", 100);
    var whenCreated = new UiColumn("whenCreated", "Date", 150);
    var customer_Name = new UiColumn("customer", "Customer", 150);
    var orderStatus = new UiColumn("status_Name", "Status", 150);
    var itemCount = new UiColumn("itemCount", "Items", 150);


    cols.push(orderNumber, whenCreated, customer_Name, orderStatus, itemCount);

    return cols;
  }

    newOrder() {
      this.router.navigate(['/RedeploymentOrder/NewOrder']);
    }

}
